
import {
    Grid,
    ExpandableSection
} from '@amzn/awsui-components-react';
import React, { useCallback, useMemo } from 'react';
import { MetricConfig } from '../Constants/metricsList';
import { MetricChart } from './MetricChart';
import { DateRangePick } from './DateRangePick'
import { useTimeRange } from '../Hooks/useTimeRange';
import { KeyPerformanceIndicators, OverallHealthMetrics, ResourceUtilizationMetrics } from '@amzn/search-services-cluster-insights-commons-lib';
import { useToastNotifications } from '../../../hooks/useToastList';
import { fetchDomainMetrics } from '../Hooks/useGetMetricsQuery';
import { useApolloClient } from '@apollo/client';

interface ClusterMetricsProps {
  domainIdentuple: string;
  startTime: number;
  endTime: number;
  period: number;
}
// TODO: Not removing older code, can be done once we verify all flows on staging
// const MetricsSection: React.FC<{
//   title: string;
//   metricsList: MetricConfig[];
//   domainIdentuple: string;
//   initialTimeRange: { startTime: number; endTime: number; period: number };
// }> = React.memo(({ title, metricsList, domainIdentuple, initialTimeRange }) => {
//   const { timeRange, setTimeRange, refreshToLatestHour, isValidRange } = useTimeRange(initialTimeRange);
//   const handleTimeRangeChange = React.useCallback((startTime: number, endTime: number, period: number) => {
//     setTimeRange({ startTime, endTime, period });
//   }, [setTimeRange]);

//   const memoizedMetricCharts = useMemo(() => 
//     metricsList.map((metricConfig) => (
//       <MetricChart
//         metricConfig={metricConfig}
//         domainIdentuple={domainIdentuple}
//         startTime={timeRange.startTime}
//         endTime={timeRange.endTime}
//         period={timeRange.period}
//       />
//     )), 
//     [metricsList, domainIdentuple, timeRange]
//   );

//   return (
//     <ExpandableSection 
//       variant="container"
//       defaultExpanded
//       headerText={title}
//     >
//       <DateRangePick
//         onTimeRangeChange={handleTimeRangeChange}
//         onRefresh={refreshToLatestHour}
//         isValidRange={isValidRange}
//       />
//       <br />
//       <Grid
//         gridDefinition={metricsList.map(() => ({ colspan: { default: 3 } }))}
//       >
//         {memoizedMetricCharts}
//       </Grid>
//     </ExpandableSection>
//   );
// });

export const ClusterMetrics: React.FC<ClusterMetricsProps> = React.memo(({
  domainIdentuple,
  startTime,
  endTime,
  period
}) => {
  const client = useApolloClient();
  const initialTimeRange = useMemo(() => ({
    startTime,
    endTime,
    period
  }), [startTime, endTime, period]);
  const fetchMetricsWithStats = useCallback(
    (_http: unknown, domainIdent: string, metricStats: Record<string, string[]>,
      range: { startTime: number; endTime: number }, p = 5) =>
      fetchDomainMetrics(client, domainIdent, metricStats, range, p),
    [client]
  );

  return (
    <>
      {/* TODO: Not removing older code, can be done once we verify all flows on staging */}
      {/* <MetricsSection
        title="Overall health metrics"
        metricsList={overallHealthMetricsList}
        domainIdentuple={domainIdentuple}
        initialTimeRange={initialTimeRange}
      />
      <br />
      <MetricsSection
        title="Key performance indicators"
        metricsList={keyPerformanceIndicatorList}
        domainIdentuple={domainIdentuple}
        initialTimeRange={initialTimeRange}
      />
      <br />
      <MetricsSection
        title="Resource utilization metrics"
        metricsList={resourceUtilizationMetricsList}
        domainIdentuple={domainIdentuple}
        initialTimeRange={initialTimeRange}
      /> */}
      <OverallHealthMetrics
        http={{}}
        basename=""
        notifications={{ toasts: useToastNotifications() }}
        domainIdent={domainIdentuple}
        fetchMetricsWithStats={fetchMetricsWithStats}
      />
      <br />
      <KeyPerformanceIndicators
        http={{}}
        basename=""
        notifications={{ toasts: useToastNotifications() }}
        domainIdent={domainIdentuple}
        fetchMetricsWithStats={fetchMetricsWithStats}
      />
      <br />
      <ResourceUtilizationMetrics
        http={{}}
        basename=""
        notifications={{ toasts: useToastNotifications() }}
        domainIdent={domainIdentuple}
        fetchMetricsWithStats={fetchMetricsWithStats}
      />
    </>
  );
});